var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import anime from 'animejs/lib/anime.es';
import BallLoader from 'ui/v1/loaders/BallLoader.vue';
var SlideConfirmation = /** @class */ (function (_super) {
    __extends(SlideConfirmation, _super);
    function SlideConfirmation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.saving = false;
        _this.open = false;
        return _this;
    }
    SlideConfirmation.prototype.mounted = function () {
        this.$root.$on('openConfirmation', this.openSlider);
        this.$root.$on('saved', this.saved);
    };
    SlideConfirmation.prototype.revert = function () {
        this.$root.$emit('confirmationDialog.reverted');
        this.closeSlider();
    };
    SlideConfirmation.prototype.save = function () {
        this.saving = true;
        this.$root.$emit('confirmationDialog.saving');
    };
    SlideConfirmation.prototype.saved = function () {
        this.closeSlider();
    };
    SlideConfirmation.prototype.openSlider = function () {
        anime({
            targets: '.slider',
            left: '0%',
            easing: 'easeOutExpo',
            begin: function (animation) {
                animation.animatables[0].target.classList.remove('hidden');
            },
        });
        this.open = true;
        this.saving = false;
    };
    SlideConfirmation.prototype.closeSlider = function () {
        if (this.open) {
            anime({
                targets: '.slider',
                left: '30%',
                easing: 'easeOutExpo',
                complete: function (animation) {
                    animation.animatables[0].target.classList.add('hidden');
                },
            });
            this.open = false;
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], SlideConfirmation.prototype, "message", void 0);
    SlideConfirmation = __decorate([
        Component({
            components: { BallLoader: BallLoader },
        })
    ], SlideConfirmation);
    return SlideConfirmation;
}(Vue));
export default SlideConfirmation;
